import { LinkProps } from 'react-router-dom';
import { EnhancedButton, EnhancedButtonProps } from './EnhancedButton';

/**
 * Proprietà specifiche per il componente `LinkEntityButton`.
 * Eredita tutte le funzionalità di `EnhancedButtonProps` ma rende obbligatoria
 * la proprietà `to` per garantire la navigazione tramite React Router.
 */
export interface LinkEnhancedButtonProps extends Omit<EnhancedButtonProps, 'to'> {
  /**
   * Rotta di destinazione per React Router.
   * Obbligatoria per questo tipo di bottone specializzato nella navigazione.
   */
  to: LinkProps['to'];
}

/**
 * `LinkEntityButton` è una specializzazione di `EnhancedButton` focalizzata sulla navigazione.
 *
 * Eredita ed esegue automaticamente la gestione delle icone, dell'internazionalizzazione
 * e dei permessi RBAC, preimpostando il look nativo `outlined` tipico dei bottoni di re-indirizzamento.
 *
 * @component
 * @example
 * ```tsx
 * <LinkEntityButton
 *   label="technician-created"
 *   prefix="dashboard"
 *   to="/technicians/archive"
 *   count={5}
 *   requirePermission="tenantAdministrator"
 * />
 * ```
 */
export default function LinkEnhancedButton({
  variant = 'outlined',
  size = 'small',
  ...props
}: LinkEnhancedButtonProps) {
  return <EnhancedButton variant={variant} size={size} {...props} />;
}
